import { create } from "zustand";

interface IFollowsStore {
  follows: string[];
  isFetched: boolean;
  isLoading: boolean;
  replaceAllFollows: (follows: string[]) => void;
  follow: (userName: string) => void;
  unfollow: (userName: string) => void;
  checkFollowing: (userName: string) => boolean;
  setFetched: (isFetched: boolean) => void;
  setLoading: (isLoading: boolean) => void;
}

export const useFollowsStore = create<IFollowsStore>(
  (set, get) => ({
    follows: [],
    isFetched: false,
    isLoading: false,
    setLoading: (isLoading: boolean) => set(() => ({ isLoading })),
    replaceAllFollows: (follows: string[]) => set(() => ({ follows })),
    follow: (userName: string) => set((state) => {
      if (!state.follows.includes(userName)) {
        return { follows: [...state.follows, userName] };
      }
      return state;
    }),
    unfollow: (userName: string) => set((state) => {
      if (state.follows.includes(userName)) {
        return { follows: state.follows.filter((name) => name !== userName) };
      }

      return state;
    }),
    checkFollowing: (userName: string) => get().follows.includes(userName),
    setFetched: (isFetched: boolean) => set(() => ({ isFetched })),
  }),
);
